import { WithInstantSearchAnalytics } from '@javascript/types/InstantSearch';
import useShortlist from './shortlistStore';

interface ShortlistButtonProps {
  stockReference: string;
}

const ShortlistButton = ({
  instantSearchAnalytics,
  stockReference,
}: ShortlistButtonProps & WithInstantSearchAnalytics): JSX.Element | null => {
  const {
    store: { shortlist, add, remove },
    hasHydrated,
  } = useShortlist();

  const isShortlisted = shortlist.includes(stockReference);

  const label = `${isShortlisted ? 'Remove from' : 'Add to'} shortlist`;

  const updateShortlistedState = () => {
    if (instantSearchAnalytics) {
      instantSearchAnalytics('conversion', label);
      instantSearchAnalytics('click', label);
    }

    if (isShortlisted) {
      remove(stockReference);
    } else {
      add(stockReference);
    }
  };

  if (!hasHydrated) {
    return null;
  }

  return (
    <button
      className="js-off--hide ac-shortlist__button"
      data-event-name="Product page: Add to shortlist"
      data-insight-event="conversion"
      onClick={updateShortlistedState}
      type="button"
    >
      <img
        alt={label}
        className={`ac-shortlist__button--${
          isShortlisted ? 'active' : 'inactive'
        }`}
        data-gtm-track="click_cta"
        data-gtm-track-label={label}
      />
    </button>
  );
};

export default ShortlistButton;
